<p class="certificate-headline">Additional Certificate Recipient linked to this certificate ({{ groupedRowsByHolder().length }})</p>
<albert-certificate-holder-entity-manager emptyMessage="No additional certificate recipients assigned."
                                          searchTooltip="Search Additional Certificate Recipients"
                                          testId="acr"
                                          [groupedRows]="groupedRows()"
                                          [searchForm]="searchForm"
                                          [searchResultRows]="searchResultRows()"
>
  <ng-template let-row
               albertHolderDisplayActions
  >
    <button iconOnly
            pButton
            pTooltip="Remove Additional Certificate Recipient"
            severity="secondary"
            tooltipPosition="left"
            type="button"
            [outlined]="true"
            (click)="onRemoveRecipient(row.holderIndex)"
    >
      <i class="pi pi-times"></i>
    </button>
  </ng-template>

  <ng-template let-row
               albertAddressDisplayActions
  >
    <button iconOnly
            pButton
            pTooltip="Remove Contact"
            severity="secondary"
            tooltipPosition="left"
            type="button"
            [outlined]="true"
            (click)="onRemoveRecipientAddress(row.holderIndex, row.addressIndex)"
    >
      <i class="pi pi-times"></i>
    </button>
  </ng-template>

  <ng-template let-row
               albertHolderSearchActions
  >
    <div class="flex gap-1">
      <button data-test="acr-add-without-emails"
              iconOnly
              pButton
              pTooltip="Add Additional Certificate Recipient"
              severity="secondary"
              tooltipPosition="left"
              type="button"
              [outlined]="true"
              (click)="onAddRecipientWithoutEmails(searchResults()[row.holderIndex]!)"
      >
        <i class="pi pi-plus"></i>
      </button>
    </div>
  </ng-template>

  <ng-template let-row
               albertAddressSearchActions
  >
    <button iconOnly
            pButton
            pTooltip="Add Contact"
            severity="secondary"
            tooltipPosition="left"
            type="button"
            [outlined]="true"
            (click)="onAddSingleRecipientEmail(row.holderIndex, row.addressIndex)"
    >
      <i class="pi pi-plus"></i>
    </button>
  </ng-template>
</albert-certificate-holder-entity-manager>
